<script lang="ts">
    import {ValueEditorSize} from '../../types';
    import KpDropdownListbox from '../../../ui-components/dropdown-listbox/KpDropdownListbox.svelte';
    import DropdownListboxAriaLabelledbyProvider from '../../../ui-components/dropdown-listbox/DropdownListboxAriaLabelledbyProvider.svelte';

    export let selectboxOptions: string[] = [];
    export let selected: string;
    export let disabled: boolean;
    export let size: ValueEditorSize = ValueEditorSize.MD;
    export let ariaLabelledby: string;
</script>
<template>
    <KpDropdownListbox value={selected}
                       options={selectboxOptions}
                       {size}
                       {disabled}
                       additionalButtonClass="form-control btn-default listbox-toggle-btn"
                       on:change>
        <svelte:fragment slot="label">
            <DropdownListboxAriaLabelledbyProvider labelId={ariaLabelledby}/>
        </svelte:fragment>
        <svelte:fragment slot="button">
            <span class="listbox-match-text">
                <slot name="button"/>
            </span>
            <i class="caret"></i>
        </svelte:fragment>
        <svelte:fragment slot="option" let:option>
            <span>
                <slot name="option" {option}/>
            </span>
        </svelte:fragment>

    </KpDropdownListbox>
</template>

<style lang="less" global>
    .listbox-match-text {
        width: 100%;
        padding-right: 10px;
    }

    .listbox-toggle-btn {
        position: relative;
        margin-left: 1px;
    }

    .input-group .form-control.listbox-toggle-btn {
        float: none;
    }
</style>